export class GeoParams {

    constructor(geoSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.geoSection = geoSection ?? null;
        this.gravitationalAccelerationG = data.gravitationalAccelerationG ?? null;
        this.densityOfWaterRoWGeoTypesPurposes = data.densityOfWaterRoWGeoTypesPurposes ?? null;
        this.unitWeightOfWaterGamaWGeoTypesPurposes = data.unitWeightOfWaterGamaWGeoTypesPurposes ?? null;

    }

}
